export const Users = [
  {
    id: 1,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis1"
  },
  {
    id: 2,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis2"
  },
  {
    id: 3,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis3"
  },
  {
    id: 4,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis4"
  },
  {
    id: 5,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis5"
  },
  {
    id: 6,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis6"
  },
  {
    id: 7,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis7"
  },
  {
    id: 8,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis8"
  },
  {
    id: 9,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis9"
  },
  {
    id: 10,
    profilePicture: "assets/profilePic.jpg",
    username: "Dennis10"
  },
];

export const Posts = [
  {
    id: 1,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 20,
    comment: 9,
  },
  {
    id: 2,
    description: "Hello this is another post from me",
    photo: "assets/view.jpeg",
    date: "10 mins ago",
    userId: 2,
    like: 52,
    comment: 19,
  },
  {
    id: 3,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "16 mins ago",
    userId: 3,
    like: 23,
    comment: 93,
  },
  {
    id: 4,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "25 mins ago",
    userId: 4,
    like: 2,
    comment: 9,
  },
  {
    id: 5,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "29 mins ago",
    userId: 5,
    like: 20,
    comment: 9,
  },
  {
    id: 6,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "32 mins ago",
    userId: 6,
    like: 20,
    comment: 9,
  },
  {
    id: 7,
    description: "Hello this is a post from me",
    photo: "assets/view.jpeg",
    date: "40 mins ago",
    userId: 7,
    like: 20,
    comment: 9,
  },
  
]